// Author: Luis Booth - October 2018

import React, { Component } from 'react';
import Slider from 'react-slick';
import PropTypes from 'prop-types';
import MagicSliderDots from 'react-magic-slider-dots';

// const isMobile = window.innerWidth < 768;

class SliderWrapper extends Component {

  render() {

    const props = { ...this.props };

    props.dotsClass = props.dotPositionInside ? 'slick-dots-inside' : 'slick-dots';

    return (
      <Slider {...props} />
    );
  }
}

SliderWrapper.defaultProps = {
  dots: true,
  dotsClass: '',
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  lazyLoad: 'ondemand',
  fade: true,
  appendDots: dots => {
    return (
      <MagicSliderDots
        dots={dots}
        numDotsToShow={5}
        dotWidth={30}
        dotContainerClassName="magic-dots slick-dots"
        activeDotClassName="slick-active"
        prevNextDotClassName="small"
      />
    );
  },
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        dots: true,
      }
    }
  ],
};

SliderWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  dotPositionInside: PropTypes.bool,
  arrowStyle: PropTypes.string,
  sliderSize: PropTypes.string,
};

export default SliderWrapper;

// children: any element
// dotPositionInside: true/false. 
// arrowStyle: simple, with circle, with box
// sliderSize: fit container, full screen



// WEBPACK FOOTER //
// ./js/components/global/SliderWrapper.js